import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Sustainability = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.sustainabilityList);

	const options = data.map((item) => ({
		...item,
		count: item?.count
	}));

	return (
		<>
			<FilterName type="SUSTAINABILITY" />
			<Checkbox data={options} type="SUSTAINABILITY" handleSearch={handleSearch} />
		</>
	);
};

export default Sustainability;
